import { RefObject, useEffect, useRef, useState } from 'react';

export const useTabsIntersecting = ({
    ref,
    rootMargin = '-40px',
}: {
    ref?: RefObject<HTMLElement>;
    rootMargin?: string;
}) => {
    const intersectionObserverPolyfill = () => import('intersection-observer');
    const observerRef = useRef<IntersectionObserver | null>(null);
    const [isIntersecting, setIsIntersecting] = useState(false);

    useEffect(() => {
        const element = ref?.current;
        let observerNode = observerRef.current as IntersectionObserver;

        const loadIntersectionObserver = async () => {
            await intersectionObserverPolyfill();
            const onIntersection = (entries: IntersectionObserverEntry[]) => {
                const [entry] = entries;
                setIsIntersecting(entry.isIntersecting);
            };
            observerNode = new IntersectionObserver(onIntersection, {
                rootMargin,
            });

            if (element) {
                observerNode.observe(element);
            }
        };

        loadIntersectionObserver();

        return () => {
            if (element && observerNode) {
                observerNode.unobserve(element);
            }
        };
    }, [ref, rootMargin, observerRef]);

    return [isIntersecting];
};
